module.exports = __webpack_public_path__ + "img/T941.3bab60db.jpg";